export enum BogeyState {
    Attack,
    Wander
}